import React from "react";

import { StringParam, useQueryParams } from "use-query-params";

import useTranslations from "../../hooks/useTranslations";
import useNormalizedSkillOptions from "../../hooks/useNormalizedSkillOptions";

import { Card, CardBody, CardHeader, TailSpin } from "../wombat-ui";

import useEvolutionChartData from "./hooks/useEvolutionChartData";
import UserGradeOverTimeLineChart from "./charts/UserGradeOverTimeLineChart";
import { useGetAnswers } from '../../graphql/generated/definitions';

type SkillEvolutionDetailProps = {
  skillId: string;
};

const SkillEvolutionDetail: React.FC<SkillEvolutionDetailProps> = ({
  skillId,
}) => {
  const t = useTranslations();

  const [{ userId }] = useQueryParams({
    userId: StringParam,
  });
  const { data: answersData, loading: answersLoading } = useGetAnswers({
    variables: { skillIds: [skillId], collaboratorId: userId },
  });

  const options = useNormalizedSkillOptions();

  const chartData = useEvolutionChartData(
    answersData?.answers.collection,
    userId,
    options
  );

  return (
    <>
      {answersLoading && (
        <div className="flex flex-col items-center justify-center flex-grow col-span-5 px-3 py-2 mb-6 space-y-4 bg-white rounded-md shadow-md h-96">
          <TailSpin className="w-6 h-6" />
        </div>
      )}
      {!answersLoading && chartData && userId && (
        <Card id={`skill-analytics-details-card-${userId}`}>
          <CardHeader>
            {t("statistics.skillEvolutionOf", {
              value: chartData[0].user,
            })}
          </CardHeader>
          <CardBody className="h-96">
            <UserGradeOverTimeLineChart data={chartData} options={options} />
          </CardBody>
        </Card>
      )}
    </>
  );
};

export default React.memo(SkillEvolutionDetail);
